import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { isApp } from "../../utils";

function Anchor(props) {
  const { children, ...otherProps } = props;
  if (isApp) {
    return <a {...otherProps}>{children}</a>;
  } else if (otherProps.to && otherProps.href) {
    return <Link {...otherProps}>{children}</Link>;
  }
  return <div {...otherProps}>{children}</div>;
}

Anchor.defaultProps = {
  children: "",
};

Anchor.propTypes = {
  children: PropTypes.node,
};
export default Anchor;



// WEBPACK FOOTER //
// ./src/component/Anchor/index.js